// index.jsx
import { cn } from "@/utils";
import * as Popover from "@radix-ui/react-popover";
import { useState } from "react";

interface Props {
  side?: "top" | "right" | "bottom" | "left";
  align?: "start" | "center" | "end";
  trigger: React.ReactNode | ((open: boolean) => React.ReactNode);
  children: React.ReactNode;
  triggerClassName?: string;
  contentClassName?: string;
  alignOffset?: number;
  sideOffset?: number;
  enableCloseOnClick?: boolean; // Mặc định là true
  asChild?: boolean; // Mặc định là false
}

export default ({
  trigger,
  children,
  side = "right",
  align = "start",
  triggerClassName,
  contentClassName,
  alignOffset = 0,
  sideOffset = 4,
  enableCloseOnClick = true,
  asChild,
}: Props) => {
  const [open, setOpen] = useState(false);

  const handleChildrenClick = () => {
    // Thêm 1 option để đóng popover khi click vào bên trong nội dung
    if (enableCloseOnClick) setOpen(false);
  };

  return (
    <Popover.Root open={open} onOpenChange={setOpen}>
      <Popover.Anchor asChild>
        <div className="Row">
          <Popover.Trigger
            className={cn("w-full", triggerClassName)}
            asChild={asChild}
          >
            {typeof trigger === "function" ? trigger(open) : trigger}
          </Popover.Trigger>
        </div>
      </Popover.Anchor>

      <Popover.Portal>
        <Popover.Content
          side={side}
          align={align}
          sideOffset={sideOffset} // cách nút 4px
          alignOffset={alignOffset} // lệch 4px so với start hoặc end
          className={cn("z-[9999]", contentClassName)}
          style={{ position: "relative" }}
        >
          <div onClick={handleChildrenClick}>{children}</div>
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
};
